export default "__VITE_ASSET__BOmiPMpQ__"